import { render, staticRenderFns } from "./wizardStep2.vue?vue&type=template&id=fc253f7c&scoped=true&"
import script from "./wizardStep2.vue?vue&type=script&lang=js&"
export * from "./wizardStep2.vue?vue&type=script&lang=js&"
import style0 from "./wizardStep2.vue?vue&type=style&index=0&id=fc253f7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc253f7c",
  null
  
)

export default component.exports